import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const ArrowUpIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon data-testid="arrow up icon" viewBox="0 0 8 4" {...props}>
    <path
      clipRule="evenodd"
      d="M7.02014 3.85353C6.82488 4.04879 6.50829 4.04879 6.31303 3.85353L3.99992 1.54042L1.68681 3.85353C1.49154 4.04879 1.17496 4.04879 0.979699 3.85353C0.784436 3.65827 0.784436 3.34169 0.979699 3.14643L3.64637 0.47976C3.84163 0.284497 4.15821 0.284497 4.35347 0.47976L7.02014 3.14643C7.2154 3.34169 7.2154 3.65827 7.02014 3.85353Z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </Icon>
);
